import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Select from 'flarum/common/components/Select';
import Button from 'flarum/common/components/Button';
import extractText from 'flarum/common/utils/extractText';
import TicketLabels from './TicketLabels';
import { priorityLabel, statusLabel, ticketAssignees, ticketGuest, TICKET_PRIORITIES, TICKET_STATUSES } from '../../common/utils/tickets';
/**
 * Sidebar box on a ticket. Staff get selects for status and priority and can
 * add or remove assignees; customers see the current values.
 */
export default class TicketControls extends Component {
  saving = false;
  static staff = null;
  oninit(vnode) {
    super.oninit(vnode);
    if (this.attrs.discussion.canManageTicket() && TicketControls.staff === null) {
      TicketControls.staff = [];
      app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl'),
        params: {
          include: 'supportStaff'
        }
      }).then(payload => {
        app.store.pushPayload(payload);
        const ids = payload.data?.relationships?.supportStaff?.data || [];
        TicketControls.staff = ids.map(_ref => {
          let {
            id
          } = _ref;
          return app.store.getById('users', id);
        }).filter(user => !!user);
        m.redraw();
      });
    }
  }
  view() {
    const discussion = this.attrs.discussion;
    const t = function (key, params) {
      if (params === void 0) {
        params = {};
      }
      return app.translator.trans(`soup-97-support.forum.ticket.${key}`, params);
    };
    if (!discussion.canManageTicket()) {
      const names = ticketAssignees(discussion).map(user => user.displayName());
      return m("div", {
        className: "TicketControls"
      }, m("h4", {
        className: "TicketControls-heading"
      }, t('heading')), m(TicketLabels, {
        discussion: discussion
      }), m("p", {
        className: "TicketControls-assignee"
      }, names.length ? t('assigned_to', {
        names: names.join(', ')
      }) : t('not_assigned')));
    }
    const statuses = {};
    TICKET_STATUSES.forEach(status => statuses[status] = extractText(statusLabel(status)));
    const priorities = {};
    TICKET_PRIORITIES.forEach(priority => priorities[priority] = extractText(priorityLabel(priority)));
    const assignees = ticketAssignees(discussion);
    const guest = ticketGuest(discussion);
    const assignedIds = assignees.map(user => user.id());

    // Staff who can still be added. Option keys must not look like integers:
    // JS orders those first.
    const addable = {
      add: extractText(t('add_assignee'))
    };
    (TicketControls.staff || []).filter(user => !assignedIds.includes(user.id())).forEach(user => addable[`user-${user.id()}`] = user.displayName());
    return m("div", {
      className: "TicketControls"
    }, m("h4", {
      className: "TicketControls-heading"
    }, t('heading')), guest && m("div", {
      className: "TicketControls-guest"
    }, m("span", null, t('guest_heading')), m("strong", null, guest.name), m("a", {
      href: `mailto:${guest.email}`
    }, guest.email)), m("label", {
      className: "TicketControls-field"
    }, m("span", null, t('status_label')), m(Select, {
      options: statuses,
      value: discussion.ticketStatus(),
      disabled: this.saving,
      onchange: value => this.save({
        ticketStatus: value
      })
    })), m("label", {
      className: "TicketControls-field"
    }, m("span", null, t('priority_label')), m(Select, {
      options: priorities,
      value: discussion.ticketPriority(),
      disabled: this.saving,
      onchange: value => this.save({
        ticketPriority: value
      })
    })), m("div", {
      className: "TicketControls-field"
    }, m("span", null, t('assignees_label')), m("ul", {
      className: "TicketControls-assignees"
    }, assignees.length === 0 && m("li", {
      className: "TicketControls-none"
    }, t('unassigned')), assignees.map(user => m("li", {
      className: "TicketControls-assigneeChip"
    }, user.displayName(), m(Button, {
      className: "Button Button--icon Button--link",
      icon: "fas fa-times",
      "aria-label": extractText(t('remove_assignee', {
        name: user.displayName()
      })),
      disabled: this.saving,
      onclick: () => this.saveAssignees(assignees.filter(other => other !== user))
    })))), Object.keys(addable).length > 1 && m(Select, {
      options: addable,
      value: "add",
      disabled: this.saving,
      onchange: value => {
        const user = app.store.getById('users', value.replace(/^user-/, ''));
        if (user) this.saveAssignees([...assignees, user]);
      }
    })));
  }
  saveAssignees(users) {
    this.save({
      relationships: {
        ticketAssignees: users
      }
    });
  }
  save(data) {
    const discussion = this.attrs.discussion;
    this.saving = true;
    discussion.save(data).then(async () => {
      // Status changes and assignments add a system post to the stream.
      if (!app.viewingDiscussion(discussion)) return;
      await app.current.get('stream').update();

      // Successive changes are merged into the latest system post, which the
      // stream doesn't reload by itself.
      const lastId = discussion.postIds().slice(-1)[0];
      if (lastId) await app.store.find('posts', lastId);
    }).catch(() => {}).finally(() => {
      this.saving = false;
      m.redraw();
    });
  }
}
flarum.reg.add('soup-97-support', 'forum/components/TicketControls', TicketControls);